/**
 *
 * Load Plugins
 * If you don't see a plugin below it might be autoloaded via webpack
 * Check webpack.mix.js for autoloaded plugins.
 *
 */
import { Foundation } from './foundation';
import ScrollMagic from 'scrollmagic';
import Cycle from 'jquery.cycle2';
Foundation.addToJquery(jQuery);
import Plyr from 'plyr';
import GLightbox from 'glightbox'
import GLightboxCss from  'glightbox/dist/css/glightbox.css';

function app() {

    // Vars
    var html = $('html');

    // Resets
    html.removeClass('modal-active');


    // Menu
    $('.nav-icon--trigger').click(function() {
        html.toggleClass('modal-active');
        // menu.addClass('menu-modal--transition');
    });

    // Slide Effects
    $('.slide-in').each(function (index, elem) {
        var scene = new ScrollMagic.Scene({
            triggerElement: elem,
            triggerHook: 0.85,
            reverse: false
        });
        scene.setClassToggle(elem, 'slide-in--active');
        controller.addScene(scene);
    });

    // Scroll Magic for vertical scrolling pages
    var verticalController = new ScrollMagic.Controller({
        vertical: true,
        loglevel: 2
    });

    $('.slide-up').each(function (index, elem) {
        var scene = new ScrollMagic.Scene({
            triggerElement: elem,
            triggerHook: 0.85,
            reverse: false
        });
        scene.setClassToggle(elem, 'slide-up--active');
        verticalController.addScene(scene);
    });

    // Create a list of grouped lightbox selectors
    const lightboxElements = [];
    $('[class^="glightbox-"]').each((i, el) => {
        let selector = el.classList[0];
        if( lightboxElements.indexOf(selector) === -1 ){
            lightboxElements.push(selector);
        }
    });

    // Create a lightbox for each section's image gallery
    lightboxElements.forEach(selector => GLightbox({ selector: selector }));
}


$(document).ready(function() {
    $(document).foundation();
    app();
});


// Resizes a video constained within a wrapper
function sizeTheVideo() {

    var aspectRatio = 1.36;

    var video = $('#'+homepageVideoId+' iframe');

    var videoHeight = video.outerHeight();
    var newWidth = videoHeight*aspectRatio;
    var halfNewWidth = newWidth/2;

    // Define the new width and centrally align the iframe
    video.css({"width":newWidth+"px","left":"50%","margin-left":"-"+halfNewWidth+"px"});
}


// Scripts to fire once dom has loaded
document.addEventListener('DOMContentLoaded', () => {

    // Accordions
    // If there is an accordion inside an accordion then data-accordion-allow-multiple needs to be used
    const accordionItems = document.querySelectorAll('[data-accordion-item]');

    if (accordionItems.length) {
        accordionItems.forEach(function(accordion) {
            const accordionLink = accordion.firstElementChild;
            bindEvent(accordionLink, 'click', toggleAccordion);
        });
    }

    function toggleAccordion(e) {
        const link = e.target;
        const parent = link.closest('[data-accordion]');
        const content = parent.querySelectorAll('[data-accordion-content]');

        content.forEach(function(content) {
            if (content.previousElementSibling === link) {
                content.classList.toggle('is-active');
                link.classList.toggle('is-active');
                link.setAttribute('aria-expanded', link.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
            }
            else {
                if(!("accordionAllowMultiple" in content.parentNode.dataset)) {
                    content.classList.remove('is-active');
                    content.previousElementSibling.classList.remove('is-active');
                    content.previousElementSibling.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }


    // Bind event
    function bindEvent(el, eventName, eventHandler) {
        if (el.addEventListener){
            el.addEventListener(eventName, eventHandler, false);
        } else if (el.attachEvent){
            el.attachEvent('on'+eventName, eventHandler);
        }
    }

})
